<template>
  <div>
    <div>
      <v-card class="px-4" flat>
        <v-layout wrap v-if="isUsingSelectEntireExperience" mt-2>
          <v-flex xs12>
            <select-entire-experience :index="index" :profile="profile" :isFromToken="isFromToken" @setIsUsingSelectEntireExperience="setIsUsingSelectEntireExperience"/>
          </v-flex>
        </v-layout>
        <v-layout wrap v-else>
          <v-flex xs12>
            <v-layout wrap mb-6 mt-6>
              <v-flex xs6>
                <v-btn @click="isUsingSelectEntireExperience = true" small class="mt-2 primary white--text">
                  <v-icon small class="mr-2">mdi-select-drag</v-icon>{{ $t('a') }}
                </v-btn>
              </v-flex>
              <v-flex xs6 text-end>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn fab @click="removeExperience" x-small elevation="0" v-bind="attrs" v-on="on">
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <small>{{ $t('deleteTooltip') }}</small>
                </v-tooltip>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout wrap justify-space-between>
              <v-flex xs5>
                <v-text-field v-model="profile.experiences[index].startDate" dense outlined :label="$t('1')"/>
              </v-flex>
              <v-flex xs5>
                <v-text-field v-model="profile.experiences[index].endDate" dense outlined :label="$t('2')"/>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-space-between>
              <v-flex xs12>
                <v-text-field v-model="profile.experiences[index].company" dense outlined :label="$t('3')"/>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-space-between>
              <v-flex xs12>
                <v-textarea auto-grow rows="1" v-model="profile.experiences[index].title" dense outlined :label="$t('4')"/>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-space-between>
              <v-flex xs12>
                <div class="mb-2">
                  <span class="primary--text">{{ $t('5') }}</span>
                </div>
                <div class="text-end">
                  <v-tooltip top class="buttonOfTooltip">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn style="position: absolute; right: 27px; margin-top: 14px" text class="primary--text" @click="resetAllIndents" x-small elevation="0" v-bind="attrs" v-on="on">
                        <v-icon class="img-horizontal-flip">mdi-playlist-remove</v-icon>
                      </v-btn>
                    </template>
                    <small>{{ $t('resetAllIndents') }}</small>
                  </v-tooltip>
                </div>
                <vue-editor ref="editor" v-model="profile.experiences[index].description" :editorToolbar="editorToolbar" :editorOptions="editorOptions"></vue-editor>
              </v-flex>
            </v-layout>
            <v-layout wrap justify-space-between class="mt-6">
              <v-flex xs12>
                <v-textarea auto-grow rows="1" v-model="profile.experiences[index].technicalEnv" dense outlined :label="$t('6')" autocomplete="false"/>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </div>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import SelectEntireExperience from '@/components/profile/SelectEntireExperience.vue';

export default {
  components: {
    SelectEntireExperience,
    VueEditor
  },
  props: {
    profile: Object,
    index: Number,
    isOcrResultsLoaded: Boolean,
    isFromToken: Boolean
  },
  data: () => ({
    editorToolbar: [[{ list: "bullet" }]],
    editorOptions: {
      formats: ['list', 'indent'],
      modules: { keyboard: { bindings: { 'tab': { key: 9, handler: function() { return false; } } } } }
    },
    isUsingSelectEntireExperience: false
  }),
  computed: {
    experienceDescription() {
      return this.profile.experiences[this.index].description
    }
  },
  mounted() {
    // If experience is empty, use selectEntireExperience tool
    // const xp = this.profile.experiences[this.index]
    // if (!xp.startDate && !xp.endDate && !xp.company && !xp.title && !xp.description && !xp.technicalEnv) {
    //   this.isUsingSelectEntireExperience = true
    // }
  },
  methods: {
    resetAllIndents() {
      this.profile.experiences[this.index].description = this.profile.experiences[this.index].description
        // Convert all paragraphs to indent lvl 0
        .replace(/<p>/g, '<ul><li class="ql-indent-0">')
        .replace(/<\/p>/g, '</li></ul>')
        .replace(/<ul><\/ul>/g, '')
        // Convert all bulletpoints to indent lvl 0
        .replace(/(<li class="ql-indent-)\d(">)/g, '<li class="ql-indent-0">')
        // Convert all empty bulletpoint to empty paragraph
        .replace(/<li class="ql-indent-0"><br><\/li>/g, '</ul><p><br></p><ul>')
        .replace(/<ul><\/ul>/g, '')
      this.$forceUpdate()
    },
    removeExperience() {
      this.profile.experiences.splice(this.index, 1);
      const xpsLength = this.profile.experiences.length
      if (xpsLength > 0) {
        if (this.index > 0) this.$emit('goToEditPreviousItem')
      } else {
        this.$emit('goBackToMainForm', { idOfElementToScrollTo: 'view-experiences', idOfElementToBlink: 'view-experiences', blinkColor: 'red', additionalPixels: -300 })
      }
    },
    setIsUsingSelectEntireExperience(data) {
      this.isUsingSelectEntireExperience = data.isUsingSelectEntireExperience
    }
  },
  watch: {
    isUsingSelectEntireExperience: {
      handler() {
        this.$emit('passIsUsingSelectEntireExperience', { isUsingSelectEntireExperience: this.isUsingSelectEntireExperience })
      }
    },
    experienceDescription: {
      handler(val) {
        if (val.includes('<li>')) {
          this.profile.experiences[this.index].description = val.replace(/<li>/g, '<li class="ql-indent-0">')
        }
      }
    }
  }
}
</script>


<i18n>
{
  "fr": {
    "1": "Date de début",
    "2": "Date de fin",
    "3": "Entreprise",
    "4": "Titre",
    "5": "Description",
    "6": "Environnement technique",
    "deleteTooltip": "Supprimer l'expérience",
    "a": "Extraire toute l'expérience d'un seul coup",
    "resetAllIndents": "Réaligner toutes les indentations en bulletpoints de niveau 1"
  },
  "en": {
    "1": "Start date",
    "2": "End date",
    "3": "Company",
    "4": "Title",
    "5": "Description",
    "6": "Technical environment",
    "deleteTooltip": "Delete the experience",
    "a": "Extract the entire experience at once",
    "resetAllIndents": "Re-align all the indents into level 1 bulletpoints"
  }
}
</i18n>